import { render, staticRenderFns } from "./Idiom.vue?vue&type=template&id=34eb5d9b&scoped=true&"
import script from "./Idiom.vue?vue&type=script&lang=js&"
export * from "./Idiom.vue?vue&type=script&lang=js&"
import style0 from "./Idiom.vue?vue&type=style&index=0&id=34eb5d9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eb5d9b",
  null
  
)

export default component.exports